module.exports = __webpack_public_path__ + "img/10.2a7b416f.png";